/**
 * The words of a site type's defaults (piece 10, piece 13, piece 15; decision 10210; T3514): the Defaults window on
 * Settings › Organization › Site Types, the Apply Site Type Defaults window over the Site's Edit form, and the role
 * editor's checkbox for the flag's permission, spread into the one string lookup.
 */
export const SITE_TYPE_DEFAULT_STRINGS = {
  'settings.siteTypes.defaults': 'Defaults',
  'settings.siteTypes.defaultsTitle': 'Site Type Defaults',
  'settings.siteTypes.defaultsHint': 'A new {name} site starts with these. Changing an existing site to {name} fills what it never set, and asks before overwriting anything set.',
  'settings.siteTypes.defaultsRequirements': 'Site requirements',
  'settings.siteTypes.defaultsNoRequirements': 'No site requirement type is set up yet.',
  'settings.siteTypes.defaultsMessages': 'Work order messages',
  'settings.siteTypes.defaultsMessagesHint': 'Each lands on the customer’s own message rule. On sends to the customer’s contacts working at the site.',
  'settings.siteTypes.defaultNone': 'No default',
  'settings.siteTypes.defaultOn': 'On',
  'settings.siteTypes.defaultOff': 'Off',
  'settings.siteTypes.defaultsTaxExempt': 'Tax exempt customer',
  'settings.siteTypes.defaultsTaxExemptHint': 'Ticked, a new site of this type starts as a tax exempt customer. Unticked, the type leaves the flag alone.',
  'settings.siteTypes.defaultsSave': 'Save Defaults',
  'siteTypeAnswer.title': 'Apply Site Type Defaults',
  'siteTypeAnswer.hint': '{type} offers its own settings. For each one, overwrite what this site has, or keep it.',
  'siteTypeAnswer.filled': 'Settings this site never set are filled from the type without asking.',
  'siteTypeAnswer.requirements': 'Site requirements',
  'siteTypeAnswer.messages': 'Work order messages',
  'siteTypeAnswer.taxExempt': 'Tax exempt customer',
  'siteTypeAnswer.now': 'This site now',
  'siteTypeAnswer.customerNow': 'The customer’s rules now',
  'siteTypeAnswer.messagesCustomer': 'These are the customer’s own rules, so overwriting them changes the messages of every site of this customer.',
  'siteTypeAnswer.messagesSkipped': 'Work order messages are passed over: filling them needs write on the Work Order module, and nothing is set for them.',
  'siteTypeAnswer.offered': 'The type offers',
  'siteTypeAnswer.overwrite': 'Overwrite',
  'siteTypeAnswer.keep': 'Keep',
  'siteTypeAnswer.apply': 'Apply',
  'siteTypeAnswer.unanswered': 'Answer Overwrite or Keep on every row first.',
  'siteTypeAnswer.nothing': 'None',
  'siteTypeAnswer.yes': 'Yes',
  'siteTypeAnswer.no': 'No',
  'siteTypeAnswer.readFailed': 'The type’s defaults could not be read, so nothing was saved.',
  'settings.roles.taxExempt': 'May change a site’s Tax exempt customer flag',
} as const;
